import { render } from "./CollectionsTableCustomizer.vue?vue&type=template&id=6473554c&scoped=true"
import script from "./CollectionsTableCustomizer.vue?vue&type=script&lang=js"
export * from "./CollectionsTableCustomizer.vue?vue&type=script&lang=js"

import "./CollectionsTableCustomizer.vue?vue&type=style&index=0&id=6473554c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6473554c"]])

export default __exports__